// import Cookies from 'js-cookie'

const state = {
  size: ''
}

const mutations = {
  SET_PAGE: (state, page) => {
    state.page = page
  }
}

const actions = {
  setPage({ commit }, page) {
    commit('SET_PAGE', page)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
